import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToastyModule } from 'ng2-toasty';
import { HttpModule, Http, XHRBackend, RequestOptions } from '@angular/http';
import { FlashMessagesModule } from 'angular2-flash-messages';
import { ReCaptchaModule } from 'angular2-recaptcha';
import { MyDatePickerModule } from 'mydatepicker';
import { AmazingTimePickerModule } from 'amazing-time-picker';

import { AppComponent } from './app.component';
import { RouterModule }   from '@angular/router';
import { AppRoutingModule }     from './app-routing.module';

import { DenunciaComponent } from './denuncia/denuncia.component';
import { EntrevistasComponent } from './entrevistas/entrevista.component';
import { ListarEntrevistasComponent } from './listar-entrevistas/listar-entrevistas.component';
import { InicioComponent } from './inicio/inicio.component';
import { PerfilComponent } from './perfil/perfil.component';
import { VinculoComponent } from './vinculo/vinculo.component';
import { IncidenteComponent } from './incidente/incidente.component';
import { ComunicadoComponent } from './comunicado/comunicado.component';
import { RelacaoIncidenteComponent } from './relacao-incidente/relacao-incidente.component';
import { DenunciasComponent } from './denuncias/denuncias.component';
//import { AuthComponent } from './auth/auth.component';
import { AuthAndACLService } from './auth_and_acl/authAndACL.service';
import { LoginComponent } from  './login/login.component';

import { TextMaskModule } from 'angular2-text-mask';

import { FileSelectDirective } from 'ng2-file-upload';
import { UsuarioComponent } from './usuario/usuario.component';
import { DenunciasdhComponent } from './denunciasdh/denunciasdh.component';

import { ModalComponent } from './denuncias/modal.component';
import { ModalResumoComponent } from './denuncias/modalresumo.component';
import { ModalResolucaoComponent } from './inicio/modalresolucao.component';
import { ModalEncaminhamentoComponent } from './denuncias/modalencaminhamento.component';
import { ModalEncaminhamentoPsicologicoComponent } from './denuncias/modalencaminhamentopsicologico.component';
import { ModalNomesEncaminhamentoPsicologicoComponent } from './denuncias/modalnomesencaminhamentopsicologico.component';
import { ModalFinalizacaoComponent } from './denuncias/modalfinalizacao.component';


import { ContratoComponent } from './contrato/contrato.component';
import { LocalComponent } from './local/local.component';
import { SplitPipe } from './split.pipe';
import { EntrevistaComponent } from './entrevista/entrevista.component';
import { AtualizarEntrevistaComponent } from './atualizar-entrevista/atualizar-entrevista.component';
import { ResumoComponent } from './resumo/resumo.component';

import {httpFactory} from "./shared/http_intercept/http.factory";
import {Utils} from "./shared/utils";
import { ValidacaoComponent } from './validacao/validacao.component';
import { SelecaoResponsaveisComponent } from './selecao-responsaveis/selecao-responsaveis.component';
import { EncaminhamentoComponent } from './encaminhamento/encaminhamento.component';
import { BuscaComponent } from './busca/busca.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { EditarUsuariosComponent } from './editar-usuarios/editar-usuarios.component';
import { RemoverUsuariosComponent } from './remover-usuarios/remover-usuarios.component';
import { AdicionarUsuariosComponent } from './adicionar-usuarios/adicionar-usuarios.component';
import { AgendamentoComponent } from './agendamento/agendamento.component';
import { TokenComponent } from './token/token.component';
import { ConfirmacaoAgendamentoComponent } from './confirmacao-agendamento/confirmacao-agendamento.component';
import { DenunciasNaoPertinentesComponent } from './denuncias/denuncias-nao-pertinentes.component';
import { DenunciasFinalizadasComponent } from './denuncias/denuncias-finalizadas.component';
import { FinalizacaoComponent } from './finalizacao/finalizacao.component';
import { ConfiguracoesComponent } from './configuracoes/configuracoes.component';
import { RelatoriosComponent } from './relatorios/relatorios.component';

@NgModule({
   declarations: [
      AppComponent,
      DenunciaComponent,
      InicioComponent,
      PerfilComponent,
      VinculoComponent,
      IncidenteComponent,
      ComunicadoComponent,
      RelacaoIncidenteComponent,
      DenunciasComponent,
      EntrevistasComponent,
      ListarEntrevistasComponent,
      //AuthComponent,
      FileSelectDirective,
      UsuarioComponent,
      DenunciasdhComponent,
      ModalComponent,
      ModalResumoComponent,
      ModalResolucaoComponent,
      ModalEncaminhamentoComponent,
      ModalEncaminhamentoPsicologicoComponent,
      ModalNomesEncaminhamentoPsicologicoComponent,
      ModalFinalizacaoComponent,
      ContratoComponent,
      LocalComponent,
      SplitPipe,
      EntrevistaComponent,
      AtualizarEntrevistaComponent,
      ResumoComponent,
      LoginComponent,
      ValidacaoComponent,
      SelecaoResponsaveisComponent,
      EncaminhamentoComponent,
      BuscaComponent,
      UsuariosComponent,
      EditarUsuariosComponent,
      RemoverUsuariosComponent,
      AdicionarUsuariosComponent,
      AgendamentoComponent,
      ConfirmacaoAgendamentoComponent,
      TokenComponent,
      DenunciasNaoPertinentesComponent,
      DenunciasFinalizadasComponent,
      FinalizacaoComponent,
      ConfiguracoesComponent,
      RelatoriosComponent
   ],
   imports: [
      BrowserModule,
      FormsModule,
      HttpModule,
      AppRoutingModule,
      FlashMessagesModule,
      TextMaskModule,
      ReCaptchaModule,
      MyDatePickerModule,
      AmazingTimePickerModule
   ],
   providers: [
      AuthAndACLService,
      Utils,
    {
      provide: Http,
      useFactory: httpFactory,
      deps: [XHRBackend, RequestOptions]
    }
   ],
   bootstrap: [AppComponent]

})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts